export const GET_LIST = 'GET_LIST';
export const GET_LIST_ITEM = 'GET_LIST_ITEM';

export const FETCH_STREAMS = 'FETCH_STREAMS';
export const FETCH_STREAMS_ITEM = 'FETCH_STREAMS_ITEM';
